<template>
  <v-select
    v-model="selectedItem"
    :items="items"
    outlined
    append-inner-icon="mdi-magnify"
    dense
    hide-details
  />
</template>
  
<script>
export default {
    props:{
        criterio: {
          default: '',
          required: false,
        }
    },
    data() {
        return {
            selectedItem: null,
            items: [],
            loading: false
        };
    },
    watch:{
        selectedItem(valor){
            let criterios = this.$store.getters['criterios/getCriterios']
            const itemEncontrado = criterios.find(item => item.sequencia === this.criterio.sequencia);
            
            if(itemEncontrado) {
                itemEncontrado['tipoOrcamento'] = valor
                this.$store.dispatch('criterios/updateCriterio', {updatedCriterio: itemEncontrado});
            }
        },
    },
    mounted() {
        this.fetchData()
        this.setup()
    },
    methods: {
        setup(){
            let criterios = this.$store.getters['criterios/getCriterios']
            const itemEncontrado = criterios.find(item => item.sequencia === this.criterio.sequencia)

            if(itemEncontrado) {
                this.value = itemEncontrado.valorTotalOrcamento
                itemEncontrado['tipoOrcamento'] = itemEncontrado.valorTotalOrcamento
                this.$store.dispatch('criterios/updateCriterio', {updatedCriterio: itemEncontrado});
            }
        },
        async fetchData() {
            this.items = [
                {
                    text: 'Consulta',
                    value: 'consulta',
                },
                {
                    text: 'Gerado a partir de OS',
                    value: 'gerado_partir_OS',
                }
            ]
        }
    }
};
  </script>   
  